let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("glVF0")).then(() => parcelRequire('gJP5f'));